import { makeStyles } from '@mui/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    marginLeft: theme.spacing(6)
  },
  rootLoading: {
    display: 'flex',
    textAlign: 'center'
  },
  '@global': {
    '.MuiTableRow-root': {
      background: '#fff'
    },
    'tr:nth-child(odd)': {
      'background-color': '#fff'
    },
    '.MuiTableCell-root': {
      fontSize: '1em',
      fontWeight: '300',
      'line-height': '0.8',
      textAlign: 'center',
      minHeight: 30,
      height: 30,
      paddingTop: 0,
      paddingBottom: 0,
      borderLeftStyle: 'solid',
      borderWidth: 1,
      borderLeftColor: '#CBC7C6'
    },
    '.MuiTableCell-head': {
      fontWeight: '500',
      color: '#0091ae',
      textTransform: 'uppercase'
    },
    '.MuiTableBody-root': {
      fontSize: '1em'
    },
    '.MuiPaper-rounded': {
      border: '1px solid #cad2e8',
      boxShadow: '0 0 black'
    },
    '.MuiTableCell-footer': {
      borderLeftStyle: 'unset',
      borderWidth: 0,
      height: 52,
     
    },
    '.MuiTableCell-head .MuiTableSortLabel-root div': {
      display: 'inline-block',
      width: '185px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'pre-line',
      textAlign: 'center'
    }
  }
});

export const useStyles = makeStyles(theme => ({
  rowHead: {
    height: '60px',
    width: '2600px',
    backgroundColor: '#0091ae',
    color: 'white'
  },
  rowOdd: {
    height: '60px',
    width: '2600px',
  },
  rowEven: {
    height: '60px',
    width: '2600px',
    backgroundColor: '#e1faff',
  },
  cell: {
    width: '100px',
    height: '60px',
    float: 'left',
    lineHeight: '60px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  filters: {
    width: 'calc(100vw - 40px)',
    height: '60px',
    textAlign: 'left'
  },
  csvLink: {
    color: '#0091ae',
    marginTop: '7px',
    display: 'inline-block',
    marginLeft: '20px'
  },
  download: {
    transform: 'translateY(10px)'
  }
}));

export default styles;
